import React from 'react'
import { useTheme } from 'styled-components'
import { SpaceProps } from 'styled-system'
import { Flex, FlexProps } from '../Flex'

interface IconWrapperProps extends FlexProps, SpaceProps {
  icon: React.ReactNode
  color?: string
  width?: number
}

const IconWrapper: React.FC<IconWrapperProps> = ({ icon, color, width, ...props }) => {
  const theme = useTheme()

  return (
    <Flex {...props}>
      {React.isValidElement(icon) &&
        React.cloneElement(icon as any, {
          color: color || theme.colors.white,
          width
        })}
    </Flex>
  )
}

export default IconWrapper
